import { addUsageLog } from '../../services/usage-log';
import { formatUserAddress } from '../users';
import EnterpriseDetails from '@/types/enterprise-detail-info';
import Nullable from '@/types/nullable';
import AdvisorContext from '@/types/advisor-context';
import User from '@/types/user';

const USAGE_LOG_PREFIX = 'HEAP_';

export enum HEAP_CUSTOM_EVENTS {
  DOWNLOAD_PROPOSAL = 'DOWNLOAD_PROPOSAL',
  LOAD_EXISTING_COMPARISON = 'LOAD_EXISTING_COMPARISON',
  LOAD_MODEL = 'LOAD_MODEL',
  NEW_COMPARISON = 'NEW_COMPARISON',
}

const identify = (user: User, locale: string, enterprise: EnterpriseDetails, context: Nullable<AdvisorContext>) => {
  window.heap.identify(user.id);
  window.heap.addUserProperties({
    name: `${user.fname} ${user.lname}`,
    _email: user.email,
    'company.id': enterprise && enterprise._id,
    'company.name': enterprise && enterprise.name,
    'advisor.context.number': context && context.advisor?.number,
    language: locale,
    address: formatUserAddress(user),
    phone: user.phone,
    id: user.id,
    uid: user.uid,
    invitedBy: user.invitedBy,
    createdAt: user.createdAt,
  });
};

const resetIdentity = () => {
  window.heap.resetIdentity();
};

const track = (eventName: HEAP_CUSTOM_EVENTS, eventProperties?: Record<string, unknown>) => {
  window.heap.track(eventName, eventProperties);
  addUsageLog(`${USAGE_LOG_PREFIX}${eventName}`, eventProperties);
};

export default {
  identify,
  resetIdentity,
  track,
};
